module.exports = "<div class=\"row wrapper border-bottom white-bg page-heading\">\n  <div class=\"col-lg-10\">\n    <h2></h2>\n    <ol class=\"breadcrumb\">\n      <li>\n        <a [routerLink]=\"['/dashboard']\">Home</a>\n      </li>\n      <li class=\"active\">\n        <strong>Dashboard</strong>\n      </li>\n    </ol>\n  </div>\n</div>\n\n<p>\n  dashboard works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.html
// module id = 1005
// module chunks = 1